
import React from 'react'
import Alert from 'react-bootstrap/Alert';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import useFormularioVacaciones from '../hooks/useFormularioVacaciones';
import Button from 'react-bootstrap/Button';
import { useEmpleadoStore } from '../stores/useEmpleadoStore';


export default function FormularioVacaciones() {

    const { camposForm, guardar, setCamposForm, mostrarAlerta, setMostrarAlerta } = useFormularioVacaciones()
	const objLogueado = useEmpleadoStore(state => state.objLogueado)

    if (!objLogueado.permitido) {
		window.location = "/"
		return (<></>)
	}


    return (
        <div className='d-flex justify-content-center'>

            <div>

                <Alert variant="info">
                    A continuación debe seleccionar un mes para sus vacaciones (julio o agosto).
                </Alert>

                <form onSubmit={guardar}>

                    <div className='row'>
                        <div className='col'>
                            <FloatingLabel controlId="floatingSelect" label="Mes de vacaciones">
                                <Form.Select aria-label="Mes de vacaciones" value={camposForm.fecha_propuesta} onChange={e => setCamposForm({ ...camposForm, fecha_propuesta: e.target.value })}>
                                    <option value={'0'}>Selecciona una opción</option>
                                    <option value="Julio">Julio</option>
                                    <option value="Agosto">Agosto</option>
                                </Form.Select>
                            </FloatingLabel>
                        </div>
                    </div>

                    <div className='d-flex justify-content-center'>
                        <Button type='submit' variant="primary" className='btn btn-primary btn-lg mt-3'>
                            Guardar datos
                        </Button>
                    </div>

                </form>


                { mostrarAlerta && <Alert variant="success" className='mt-3' dismissible onClose={() => setMostrarAlerta(false)}>
                    <b>Solicitud guardada con éxito</b>
                    <p>Las fechas serán confirmadas por el departamento de RRHH.</p>
                </Alert> }

            </div>
            {/* <Toaster/> */}


        </div>
    )
}
